module.exports = __webpack_public_path__ + "static/media/robot-orange-1.e25be680.svg";